export class Currency {
  country: string;
  types: any[] = [];
  id: number;

  setFromApiModel(apiModel: any, index: number): this {
    this.country = apiModel.country;
    this.id = ++index;
    if (apiModel.types.length) {
      apiModel.types.map(item => {
        this.types.push({
          currency: item.currency,
          id: item.credential_id
        });
      });
    }
    return this;
  }
}
